import { z } from "zod/v4";
import { MarketingEntryPoint } from "../../advanced-flow/schemas/marketing/marketing";
import {
  CustomerCustomFieldDataType,
  customerCustomFieldValueSchema,
} from "../../customer-custom-fields/customer-custom-fields-definition";

export const signupFormDataSchema = z.object({
  email: z.string().optional(),
  phone: z.string().optional(),
  birthday: z.date().optional(),
  customFields: z
    .array(
      z.object({
        declarationId: z.string(),
        dataType: z.enum(CustomerCustomFieldDataType),
        value: customerCustomFieldValueSchema,
      }),
    )
    .optional(),
});
export type SignupFormData = z.infer<typeof signupFormDataSchema>;

// email or phone number
export const submitSignupFormStepSchema = {
  name: "submitSignupFormStep" as const,
  input: z.object({
    formId: z.string(),
    stepIndex: z.number(),
    formData: signupFormDataSchema,
    customerId: z.string().nullable(),
    entryPoint: z.enum(MarketingEntryPoint),
    anonymousId: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    error: z.string().optional(),
    customerId: z.string().nullable(),
  }),
};
